interface Props {
   children: React.ReactNode;
}
export default function TableRowHeader({ children }: Props) {
   return <th className="px-4 py-3 ">{children}</th>;
}
